exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-body[data-v-2e087bf6] table > tbody > tr > td {\n  cursor: pointer;\n}\n", ""]);

// exports
